/* global bocAmchart */

/**
 * Wrapper for the function below to allow catching the errors and outputting the console errors if needed
 *
 * @param {object} data object containing the valet response
 * @param {object} dataLoader object
 * @param {object} chart object
 * @returns {array} output array of data
 */
bocAmchart.postProcessValet = function (data, dataLoader, chart) {
    try {
        return bocAmchart.doPostProcessValet(data, dataLoader, chart);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        throw (e);
    }
};

/**
 *  Produces and returns an array of data based on the valet
 *  If the size of the array of data is 1, then change the styling of line series to show bullets
 *
 * @param {object} data Object containing the valet data sets
 * @param {object} dataLoader object
 * @param {object} chart object
 * @returns {array} output array of data
 */
bocAmchart.doPostProcessValet = function (data, dataLoader, chart) {
    var output = [];
    var revisedText;
    revisedText = bocAmchart.getRevisedText();

    // If the data is compressed, uncompress it
    data = bocAmchart.decodeData(data, chart);

    if (bocAmchart.debug(chart)) {
        // eslint-disable-next-line no-console
        console.log(
            chart.bocSettings.id,
            "Running doPostProcessValet, input data:",
            data
        );
    }

    if ((!chart.hasOwnProperty("graphs") || chart.graphs.length === 0)
        && data.hasOwnProperty("seriesDetail")) {
        // Collect all the series available in the data
        var seriesSet = [];

        for (var prop in data.seriesDetail) {
            if (seriesSet.indexOf(prop) === -1) {
                bocAmchart.addGraph(
                    chart,
                    prop,
                    data.seriesDetail[prop].label
                );
            }
        }
    }

    data.observations.forEach(function (set) {
        var dateSet = [];
        for (var property in set) {
            if (set.hasOwnProperty(property)) {
                if (property === 'd') {
                    dateSet.date = set.d;
                } else {
                    dateSet[property] = set[property].v;
                    if (set[property].hasOwnProperty('r') && set[property].r === 1) {
                        dateSet[property + '_R'] = revisedText;
                    }
                    bocAmchart.initChartVars(chart);
                    bocAmchart.vars[chart.bocSettings.id].dashed = bocAmchart.vars[chart.bocSettings.id].dashed || {};

                    if (bocAmchart.vars[chart.bocSettings.id].dashed.hasOwnProperty(property)) {

                        var dashed = bocAmchart.vars[chart.bocSettings.id].dashed[property];

                        var dashLength = 6;
                        if (dashed.hasOwnProperty('length')) {
                            dashLength = parseInt(dashed.length);
                        }

                        if (dashed.hasOwnProperty('start') && dashed.hasOwnProperty('end')) {
                            if (dateSet.date >= dashed.start && dateSet.date <= dashed.end) {
                                dateSet[property + "_dashLength"] = dashLength;
                            } else {
                                dateSet[property + "_dashLength"] = 0;
                            }
                        } else {
                            if (dashed.hasOwnProperty('start')) {
                                if (dateSet.date >= dashed.start) {
                                    dateSet[property + "_dashLength"] = dashLength;
                                } else {
                                    dateSet[property + "_dashLength"] = 0;
                                }
                            }
                        }
                    }
                }
            }
        }
        output.push(dateSet);
    });

    bocAmchart.getChartTitlesFromGroup(data, chart);

    if (chart.bocSettings.args.hasOwnProperty("callback")) {
        if (bocAmchart.debug(chart)) {
            // eslint-disable-next-line no-console
            console.groupCollapsed(chart.bocSettings.id + " running callback " + chart.bocSettings.args.callback);
            // eslint-disable-next-line no-console
            console.log(window[chart.bocSettings.args.callback].toString());
            // eslint-disable-next-line no-console
            console.groupEnd();
        }
        window[chart.bocSettings.args.callback](chart, output);
    }

    bocAmchart.updateLastModifiedDates(chart, output);
    bocAmchart.updateLastValues(chart, output);
    bocAmchart.processSubtitle(chart, output);

    chart.graphs.forEach(function (graph) {
        if (isSingleDataPoint(output, graph) && graph.type === "line" && graph.bullet === "none") {
            graph.bullet = "round";
        }
    });

    if (bocAmchart.debug(chart)) {
        // eslint-disable-next-line no-console
        console.log(
            chart.bocSettings.id,
            "After doPostProcessValet, output:",
            output
        );
    }

    return output;
};

/**
 * Checks if the graph/series contains only 1 data point
 * @param {array} output    array of date objects that contain key-values to all the series
 * @param {object} graph    graph object containing all graph metadata
 * @returns {boolean}   true if theres only 1 or 0 data point else false if there is more than 1
 */
function isSingleDataPoint(output, graph) {
    var dataCount = 0;
    for (var i = 0; i < output.length; i++) {
        if (graph.valueField in output[i]) {
            if (dataCount++ > 1) {
                return false;
            }
        }
    }
    return true;
}
